module.exports = __webpack_public_path__ + "img/product_placeholder--basic.c0a9a81.png";